import { communityReviewsOnLoadHandler } from "./blocks/CommunityReviews";
import { perksSectionOnLoadHandler } from "./blocks/PerksSection";
import { gallerySliderOnLoadHandler } from "./blocks/GallerySlider";
import { tourReviewsOnLoadHandler } from "./blocks/TourReviews";
import { testimonialSliderOnLoadHandler } from "./blocks/TestimonialSlider";

// $(window).on('load', function () {
//     hidePreloader();
// });

var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
    navigator.userAgent
)
    ? true
    : false;

$(document).ready(function () {

    const ON_LOAD_SERVICES = [
        communityReviewsOnLoadHandler,
        perksSectionOnLoadHandler,
        gallerySliderOnLoadHandler,
        tourReviewsOnLoadHandler,
        testimonialSliderOnLoadHandler
    ];
    ON_LOAD_SERVICES.forEach((service) => service());

    //> Lazy load img
    // .lazy data-src
    $('.lazy').lazyload({
        effect: 'fadeIn',
    });
    //
    const tnsCarousel = document.querySelectorAll('.blog_row');
    tnsCarousel.forEach((slider) => {
        const tnsSlider = tns({
            container: slider,
            items: 3,
            gutter: 15,
            edgePadding: 0,
            slideBy: 1,
            autoWidth: true,
            controls: false,
            nav: false,
            loop: false,
            mouseDrag: false,
            responsive: {
                768: {
                    gutter: 0,
                },
            },
        });
    });

    // Sticky Tour Navbar
  if ($(".tourOverview__nav").length > 0) {
    // Get the initial position of the navigation
    var navPosition = $(".tourOverview__nav").offset().top;

    $(window).scroll(function () {
      // Check if the user has scrolled past the navigation's original position
      if ($(window).scrollTop() > navPosition) {
        // Apply styling for the sticky navigation
        $(".tourOverview__navSticky").css({
          display: "block",
          position: "fixed",
          top: "0",
        });

        // Hide the main header
        $(".header-sticky").css({
          visibility: "hidden",
          transition: "none",
        });

        // Adjust positioning for the navigation when admin bar is present
        $(".admin-bar .tourOverview__navSticky").css({
          top: "32px",
        });
      } else {
        // Reset styling when user scrolls back to the top
        $(".tourOverview__navSticky").css({
          display: "none",
          position: "static",
          top: "0",
        });

        // Make the main header visible again
        $(".header-sticky").css({
          visibility: "visible",
        });
      }
    });
  }

    // SCroll to Top
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 500) {
            $('.scrollTop').css('height', '40px');
        } else {
            $('.scrollTop').css('height', '0');
        }
    });

    $('.scrollTop').on('click', function (event) {
        event.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });

    // Blog reading progress bar
    $(window).scroll(function () {
        var percent =
            (100 * $(window).scrollTop()) /
            ($(document).height() - $(window).height());
        $('.progress').css('width', parseInt(percent) + '%');
    });

    // Sticky Tour Navbar
    if ($('.header-sticky').length > 0) {
        var navPosition = $('.section-actions').offset().top - 150;

        $(window).scroll(function () {
            if ($(window).scrollTop() > navPosition) {
                if (isMobile) {
                    $('.header-sticky').css({
                        display: 'block',
                        position: 'fixed',
                        bottom: '0',
                    });
                } else {
                    $('.header-sticky').css({
                        display: 'block',
                        position: 'fixed',
                    });
                }
            } else {
                $('.header-sticky').css({
                    display: 'none',
                    position: 'static',
                });
            }
        });
    }

    $('.faq_question').on('click', function (e) {
        e.preventDefault();

        $(this)
            .toggleClass('active')
            .parent()
            .find('.faq_answer')
            .slideToggle();
    });

    //tiny slider blog

    //> anchor scrolling
    // $(document).on('click', '.scrolling', function(e){
    //   e.preventDefault();

    //   var href  = $(this).attr('href'),
    //   top = $(href).offset().top;

    //   hideMobileMenu($(".menu-burger"), true);

    //   $('body,html').animate({scrollTop: top}, 1500);

    //   history.pushState(null, null, '#' + $(this).attr('href').split('#')[1]);
    // });
    //<

    //> tooltips
    // var showingTooltip = null;
    // $(document).on('mouseover', '.action-tooltip', function(){
    //   var tooltipContent = $(this).data('tooltip-content'),
    //       tooltipPosition = $(this).data('tooltip-position'),
    //       offset = 6;

    //   showingTooltip = insertTooltip($(this), tooltipContent, tooltipPosition, offset);
    // });
    // $(document).on('mouseout', '.action-tooltip', function(){
    //   if(showingTooltip){
    //     $('.tooltip--notice').remove();
    //     showingTooltip = null;
    //   }
    // });
    //<

    //>slider
    // $('.s2-carousel').slick({
    //   lazyLoad: 'ondemand',
    //   infinite: true,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   arrows: true,
    //   dots: false,
    //   cssEase: 'linear',
    //   prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg><use xlink:href="#arrow"></use></svg></button>',
    //   nextArrow: '<button type="button" class="slick-next slick-arrow"><svg><use xlink:href="#arrow"></use></svg></button>',
    //   responsive: [
    //       {
    //           breakpoint: 320,
    //           settings: {
    //               slidesToShow: 1
    //           }
    //       },
    //   ]
    // });

    //
    // $('.slick-slider').each(function(){
    //   var slickOptionsResponsive = [],
    //       slickOptions = {};

    //   slickOptionsResponsive = [
    //     {
    //       breakpoint: 449.99,
    //       settings: {
    //         slidesToShow: 2,
    //         centerMode: false,
    //         infinite: true,
    //       }
    //     },
    //   ];

    //   if( $(this).hasClass('news-slider') ){
    //     slickOptionsResponsive = [
    //       {
    //         breakpoint: 449.99,
    //         settings: {
    //           slidesToShow: 2,
    //           centerMode: false,
    //           infinite: true,
    //         }
    //       },
    //     ];
    //   }

    //   slickOptions = {
    //     lazyLoad: 'ondemand',
    //     infinite: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     prevArrow: $(this).siblings('.slider-header').find('.slider-header-nav__arrow--left'),
    //     nextArrow: $(this).siblings('.slider-header').find('.slider-header-nav__arrow--right'),
    //     cssEase: 'linear',
    //     centerMode: true,
    //     centerPadding: '33px',
    //     mobileFirst: true,
    //     responsive: slickOptionsResponsive
    //   }

    //   $(this).slick(slickOptions);
    // });
    //<
});

(function ($) {
    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap($el) {
        // Find marker elements within map.
        var $markers = $el.find('.marker');

        // Create gerenic map.
        var mapArgs = {
            zoom: $el.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };
        var map = new google.maps.Map($el[0], mapArgs);

        // Add markers.
        map.markers = [];
        $markers.each(function () {
            initMarker($(this), map);
        });

        // Center map based on markers.
        centerMap(map);

        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker($marker, map) {
        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
        });

        // Append to reference for later use.
        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap(map) {
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        // Case: Single marker.
        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());

            // Case: Multiple markers.
        } else {
            map.fitBounds(bounds);
        }
    }

    // Render maps on page load.
    $(document).ready(function () {
        $('.acf-map').each(function () {
            var map = initMap($(this));
        });
    });

    // Newsletter submission confirmation
    $('.newsletter_form').submit(function (e) {
        $('.form_content').hide();
        $('.form_confirm').show();
    });

    // Blog reading progress bar

    $(window).scroll(function () {
        var percent =
            (100 * $(window).scrollTop()) /
            ($(document).height() - $(window).height());
        $('.progress').css('width', parseInt(percent) + '%');
    });

    /****************************************
     * Reveal Full Content
     ****************************************/
    document.addEventListener('click', e => {
        if (!e.target.closest('.read-more')) return;

        const wrapper = e.target.closest('.tourDetails__content');

        if (wrapper == null) return;

        const visibleContent = wrapper.querySelector('.details__content.show');
        const invisibleContent = wrapper.querySelector('.details__content:not(.show)');

        if (visibleContent != null) visibleContent.classList.toggle('show');
        if (invisibleContent != null) invisibleContent.classList.toggle('show');

    });

    $(".contentBlock__content .read-more").on("click keypress", function (ev) {
        // Toggle the visibility of additional content
        $(".contentBlock__content").toggleClass("show");
    });

    $(window).on("scroll", function () {
        var scrollPos = $(window).scrollTop();
        $(".navSticky-menu a").each(function () {
          var currLink = $(this);
          var offset = 85;
          var refElement = $(currLink.attr("href"));
          if (
            refElement.position().top <= scrollPos + offset &&
            refElement.position().top + refElement.height() > scrollPos + offset
          ) {
            // Highlight active section in navigation menu
            $(".navSticky-menu a").removeClass("active");
            currLink.addClass("active");
          } else {
            currLink.removeClass("active");
          }
        });
      });

    (() => {
        const button = document.querySelector('.scroll-to-tours');
        const tours = document.querySelector('.tours-section');

        if (button == null || tours == null) return;

        button.addEventListener('click', (e) => {
            e.preventDefault();
            tours.scrollIntoView({
                behavior: 'smooth'
            });            
        });
    })();

    (() => {
        const overlay = document.querySelector('.video-overlay');
        if (overlay == null) return;
        overlay.addEventListener('click', (e) => {
            e.preventDefault();
            
            const wrapper = e.currentTarget.closest('.video-wrapper-inner');
            if (wrapper == null) return;
            const iframe = wrapper.querySelector('iframe');
            if (iframe == null) return;

            iframe.src += '&autoplay=true';
            e.currentTarget.style.setProperty('display', 'none');
        });
    })();

    $('.header-banner__close').on('click', (e) => {
        e.preventDefault();
        $(e.target).parents('.header-banner').slideUp(500, () => {
          $(e.target).remove();
        });
    });

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get the value of a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }

    (() => {
        const element = document.getElementById('currency-switcher');
        if (element == null) return;
        const select = new TomSelect(element, {
            create: false
        });
        select.on('change', (e) => {
            setCookie('selected_currency', e, 30);

            window.directCheckoutWidgetConfig.currency = e.toUpperCase();
            document.dispatchEvent(
                new Event("directCheckoutWidgetConfigChanged")
            );

            document.body.classList.add('currency-' + e.toLowerCase());

            for (var i = 0; i < element.options.length; i++) {
                const option = element.options[i];
                const value = option.value;

                if ( value !== e ) {
                    document.body.classList.remove('currency-' + value.toLowerCase());
                }
            }
        })
    })();

    (() => {
        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('.checkout-trigger');
            if (trigger == null || window.Ventrata == null) {
                return;
            }
            
            e.preventDefault();

            const productID = trigger.dataset.product;
            const optionID = trigger.dataset.option;

            let currency = getCookie('selected_currency');

            if (!currency) {
                currency = window.applicationOptions.selectedCurrency
                    ? window.applicationOptions.selectedCurrency
                    : 'USD';
            }

            if ( ! productID) {
                return;
            }

            const options = {
                productID: productID,
                optionID: optionID,
                currency: currency,
                env: 'live'
            };

            if (optionID) {
                options.optionID = optionID;
            }

            window.Ventrata(options);
        });
    })();

    const accordionClickListener = (e) => {
        const element = e.target.closest('.acrd-trigger');
        element.classList.toggle("active");
        var panel = element.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null; // Close the accordion panel
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px"; // Open the accordion panel
        }
    }

    const CLICK_HANDLERS = {
        '.acrd-trigger': accordionClickListener,
    };

    document.addEventListener('click', (e) => {
        for (const [key, value] of Object.entries(CLICK_HANDLERS)) {
            if (e.target.closest(key)) {
                value(e);
            }
        }
    });


    const testVariants = {
        62939: {
            144039: () => {
                const urls = {
                    '/statue-of-liberty-and-ellis-island-tour': '/statue-of-liberty-ellis-island-tour',
                    '/statue-of-liberty-express-tour': '/statue-of-liberty-express'
                }

                const currentUrl = window.location.href;
                
                for (const key in urls) {
                    if (currentUrl.includes(key)) {
                        window.location.href = urls[key];
                        break;
                    }
                }
            }
        }
    };

    function setBodyClassBasedOnABTests() {
        const urlParams = new URLSearchParams(window.location.search);
        const testIdParam = urlParams.get('test_id');
        const variantIdParam = urlParams.get('variant_id');
    
        if (testIdParam && variantIdParam && testVariants[testIdParam] && testVariants[testIdParam][variantIdParam]) {
            return testVariants[testIdParam][variantIdParam]();
        }
    
        const cookieValue = decodeURIComponent(document.cookie);
        const match = cookieValue.match(/mktz_ab=(.*?)(;|$)/);
        if (!match) return;
    
        const decodedCookieValue = decodeURIComponent(match[1]);
        const cookieData = JSON.parse(decodedCookieValue);
    
        for (const testId in cookieData) {
            const variantId = cookieData[testId]?.l;
            if (variantId && testVariants[testId] && testVariants[testId][variantId]) 
                testVariants[testId][variantId]();
        }
    }

    setBodyClassBasedOnABTests();

    $(document).ready(() => {
        setTimeout(setBodyClassBasedOnABTests, 500);
    });


    const sidebar = $('.blog-sidebar');
    function adjustSidebar() {
        if (sidebar.length < 1) {
            return;
        }

        const sidebarHeight = sidebar.outerHeight();
        const windowHeight = $(window).height();
        sidebar.css('position', windowHeight < sidebarHeight ? 'static' : 'sticky');
    }
    adjustSidebar();
    $(window).on('resize', adjustSidebar);

})(jQuery);
